module.exports = __webpack_public_path__ + "static/media/newHere.bd2b26a8.jpg";